const localStorageKey = "isSoundPlayingEnabled";

const enableSound = () => {
  localStorage.setItem(localStorageKey, "true");
}

const disableSound = () => {
  localStorage.setItem(localStorageKey, "false");
}

const getSound = () => {
  return !!JSON.parse(localStorage.getItem(localStorageKey));
}


const playSound = async (path) => {
  if(localStorage.getItem(localStorageKey)=="true")
    return new Audio(path).play();
  return Promise.resolve();
};

export {
  getSound,
  enableSound, 
  disableSound,
  playSound
};
